import React from 'react'
import Particle from '../components/particles'
import Aboutme from '../components/Aboutme'
import Skills from '../components/skills'
import Project from '../components/project'
import Footer from '../components/footer'

function Main() {
    return (
        <div>
            <Particle />
            <Aboutme />
            <Skills />
            <Project />
            <Footer />
        </div>
    )
}

export default Main
